import { ChainNetwork } from './networks'

export const BLOCK_EXPLORER_URLS: Record<ChainNetwork, string> = {
  ARB: 'https://arbiscan.io',
  AVAX: 'https://snowtrace.io',
  BASE: 'https://basescan.org',
  BSC: 'https://bscscan.com',
  CELO: 'https://celoscan.io',
  ETH: 'https://etherscan.io',
  FTM: 'https://ftmscan.com',
  GNO: 'https://gnosisscan.io',
  LIN: 'https://lineascan.build',
  OP: 'https://optimistic.etherscan.io',
  POLY: 'https://polygonscan.com',
  SOL: 'https://solscan.io',
  SX: 'https://explorer.sx.technology',
} as const

export const getTokenExplorerUrl = (
  network: ChainNetwork,
  address: string
): string => `${BLOCK_EXPLORER_URLS[network]}/token/${address}`

export const getTransactionExplorerUrl = (
  network: ChainNetwork,
  txHash: string
): string => `${BLOCK_EXPLORER_URLS[network]}/tx/${txHash}`

export const getAddressExplorerUrl = (
  network: ChainNetwork,
  address: string
): string =>
  network === 'SOL'
    ? `${BLOCK_EXPLORER_URLS[network]}/account/${address}`
    : `${BLOCK_EXPLORER_URLS[network]}/address/${address}`
